'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var slicedToArray = require('../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var React = require('react');
var LeftNavigationContext = require('./LeftNavigationContext.js');
var LeftNavigationItem = require('./LeftNavigationItem.js');
var Badge = require('../../DataDisplay/Badges/Badge.js');
var ExpandLess = require('../../../IconsAndImages/Icons/ExpandLess.js');
var ExpandMore = require('../../../IconsAndImages/Icons/ExpandMore.js');
var Collapse = require('../../../node_modules/@material-ui/core/esm/Collapse/Collapse.js');
var List = require('../../../node_modules/@material-ui/core/esm/List/List.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var LeftNavigationItemGroup = function LeftNavigationItemGroup(_ref) {
  var label = _ref.label,
      _ref$expandableBadge = _ref.expandableBadge,
      expandableBadge = _ref$expandableBadge === void 0 ? false : _ref$expandableBadge,
      _ref$initialOpenState = _ref.initialOpenState,
      initialOpenState = _ref$initialOpenState === void 0 ? false : _ref$initialOpenState,
      handleTabChange = _ref.handleTabChange,
      children = _ref.children;

  var _useLeftNavigationCon = LeftNavigationContext.useLeftNavigationContext(),
      addCollapsableState = _useLeftNavigationCon.addCollapsableState,
      currentTabValue = _useLeftNavigationCon.currentTabValue;

  var _useState = React.useState(initialOpenState),
      _useState2 = slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var icon = open ? React__default["default"].createElement(ExpandLess, null) : React__default["default"].createElement(ExpandMore, null);
  var expandIcon = expandableBadge ? React__default["default"].createElement(Badge, {
    color: "primary",
    variant: "dot"
  }, icon) : icon;
  React.useEffect(function () {
    addCollapsableState(defineProperty({}, label, open));
  }, [open]);

  var onClick = function onClick() {
    return setOpen(!open);
  };

  var childrenValues = React__default["default"].Children.map(children, function (child) {
    return child['props'].value;
  });
  var parentIsSelected = !open && childrenValues.includes(currentTabValue);

  var childIsSelected = function childIsSelected(child) {
    return open && child['props'].value == currentTabValue;
  };

  return React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement(LeftNavigationItem, {
    label: label,
    onClick: onClick,
    icon: expandIcon,
    selected: parentIsSelected
  }), React__default["default"].createElement(Collapse["default"], {
    "in": open,
    timeout: 0,
    unmountOnExit: true
  }, React__default["default"].createElement(List["default"], {
    component: "div",
    disablePadding: true
  }, React__default["default"].Children.map(children, function (child) {
    if (React.isValidElement(child)) {
      return React__default["default"].cloneElement(child, {
        selected: childIsSelected(child),
        handleTabChange: handleTabChange,
        style: {
          paddingLeft: 36
        }
      });
    }
  }))));
};

module.exports = LeftNavigationItemGroup;
